import _Drawer from "@arco-design/web-react/es/Drawer";
import _Link from "@arco-design/web-react/es/Link";
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import DiffTokens from '../../themePublish/diffToken';
import useLocale from '@src/hooks/useLocale';
import locale from '../locale';
export default function EditHistory(_a) {
  var themeId = _a.themeId;
  var _b = __read(useState(false), 2),
    visible = _b[0],
    setVisible = _b[1];
  var t = useLocale(locale).t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Link, {
    onClick: function onClick() {
      setVisible(true);
    },
    style: {
      fontSize: 12
    }
  }, t['autoSave.modal.edit.history']), visible && /*#__PURE__*/React.createElement(_Drawer, {
    title: t['autoSave.modal.edit.history'],
    visible: visible,
    width: 861,
    footer: null,
    onCancel: function onCancel() {
      setVisible(false);
    }
  }, /*#__PURE__*/React.createElement(DiffTokens, {
    themeId: themeId,
    tableProps: {
      size: 'middle',
      pagination: {
        defaultPageSize: 15
      }
    }
  })));
}